<h1 mat-dialog-title class="language-dialog-title">
  {{ 'HEADER.LANGUAGE.TITLE' | translate }}

  <button
    mat-icon-button
    class="close-button"
    (click)="close()"
    aria-label="Dialog schließen"
  >
    <mat-icon>close</mat-icon>
  </button>
</h1>

<mat-dialog-content class="language-dialog-content">
  <mat-selection-list [multiple]="false">
    <mat-list-option
      *ngFor="let lang of data.languages"
      [value]="lang.value"
      [selected]="lang.value === data.selectedLang"
      [attr.cdkFocusInitial]="lang.value === selectedLangValue ? '' : null"
      (click)="onSelect(lang.value)"
    >
      <div class="lang-row">
        <span class="lang-flag" aria-hidden="true">
          <i [ngClass]="lang.flagIconClass"></i>
        </span>

        <div class="lang-text">
          <div class="lang-name">
            {{ lang.viewValue }}
          </div>
        </div>
      </div>
    </mat-list-option>
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions class="language-dialog-actions">
  <button
    mat-flat-button
    color="primary"
    class="save-button"
    (click)="save()"
    [disabled]="!selectedLangValue"
  >
    {{ 'HEADER.LANGUAGE.BUTTON_SAVE' | translate }}
  </button>
</mat-dialog-actions>
